<script setup>
import { AccordionRoot, useForwardPropsEmits } from "reka-ui";

const props = defineProps({
  type: { type: String, default: "single" },
  modelValue: { type: [String, Array], default: undefined },
  defaultValue: { type: [String, Array], default: undefined },
  collapsible: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  dir: { type: String, default: "ltr" },
  orientation: { type: String, default: "vertical" },
});

const emit = defineEmits(["update:modelValue"]);

const forwarded = useForwardPropsEmits(props, emit);
</script>

<template>
  <AccordionRoot v-bind="forwarded">
    <slot />
  </AccordionRoot>
</template>
